@if (canLaunch) {
  <div class="vl-tile">
    <div class="vl-tile__body">
      <i class="las la-photo-video vl-tile__icon"></i>
      <div>
        <div class="vl-tile__title">Video Library</div>
        <div class="vl-tile__subtitle">
          Recordings of past online sessions. Opens in a new tab, so allow pop-ups if nothing appears.
        </div>
      </div>
    </div>
    <button class="btn btn-outline-primary vl-tile__action"
      [disabled]="launching"
      (click)="launchVideoLibrary()">
      {{ launching ? 'Opening…' : 'Open Video Library' }}
    </button>
  </div>
}
